import {useState} from "react";
import {FiRotateCcw} from "react-icons/fi";

import {Button} from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";
import {useAnalyzerContext} from "@/pages/analyzer/hooks/AnalyzerContext.tsx";

export const AnalyzerStartOverButton = () => {
  const {isActive, reset} = useAnalyzerContext();
  const [showConfirm, setShowConfirm] = useState(false);

  if (!isActive) return null;

  return (
    <>
      <Button variant="secondary" size="large" onClick={() => setShowConfirm(true)}>
        <Icon icon={FiRotateCcw} />
        Start Over
      </Button>
      <ActionDialog
        show={showConfirm}
        title="Start over?"
        confirmBtnText="Confirm"
        cancelBtnText="Cancel"
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => {
          reset();
          setShowConfirm(false);
        }}
      >
        This clears your current conversation and any proposed Checks, Reports, or edits generated so far, and returns
        you to the start. This can't be undone.
      </ActionDialog>
    </>
  );
};
